import { Component, NgZone, OnInit, TemplateRef } from '@angular/core';
import { SelectModel } from '../../../models/select.model';
import { Constant } from '../../../infrastructure/constant';
import { ShipmentPartner } from '../../../models/shipmentPartner.model';
import { Marker } from '../../../view-model/index';
import { Shipment, User } from '../../../models';
import { AuthService, CompartmentsService, DistrictService, HubService, ShipmentService, StreetService, TPLService, TruckService, WardService } from '../../../services';
import { LazyLoadEvent, MenuItem, MessageService, SelectItem } from 'primeng/primeng';
import { ListShipmentDeliveryPlaceFilter } from '../../../models/listShipmentDeliveryPlaceFilter.model';
import { SearchDate } from '../../../infrastructure/searchDate.helper';
import { VehicleServices } from '../../../services/vehicle.services';
import { Street } from '../../../models/street.model';
import { SoundHelper } from '../../../infrastructure/sound.helper';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Table } from 'primeng/table';
import { AssignDeliveryModel } from '../../../models/assignDelivery.model';
declare let google: any;

@Component({
  selector: 'app-delivery-shipment-to-partner',
  templateUrl: './delivery-shipment-to-partner.component.html',
  styles: []
})
export class DeliveryShipmentToPartnerComponent implements OnInit {
  parentPage = Constant.pages.shipmentPartnerManagement.name;
  currentPage = Constant.pages.shipmentPartnerManagement.children.deliveryShipmentToPartner.name

  data: ShipmentPartner = new ShipmentPartner();
  listServiceAhamove: SelectItem[] = [];
  listPartner: SelectModel[] = [
    { label: 'Ahamove', value: 1 }
  ]
  //
  GoogleAutocomplete: any;
  sessionToken: any;
  autocompleteItemsTo;
  autocompleteItemsFrom;
  geocoder: any;
  ///
  isSuccessLocationTo: boolean;
  isSuccessLocationFrom: boolean;
  loadingAutoCompleteAddressTo: boolean;
  loadingAutoCompleteAddressFrom: boolean;
  timerAutoCompleteAddress: any;
  activeSearchGoogleTo: any;
  activeSearchGoogleFrom: any;
  cloneSearchGoogleTo: any;
  cloneSearchGoogleFrom: any;
  lengthSearchGoogleTo: any;
  lengthSearchGoogleFrom: any;
  // Googlea map
  markers: Marker[];
  markersUser: Marker = new Marker();
  lat = 21.019614;
  lng = 105.841513;
  zoom: number;
  latlng: any[] = []
  icon = 'assets/images/maps/offline.png';
  infoWindowOpen: boolean = false;
  //
  dataSourceLeft: Shipment[] = [];
  totalRecordLeft: number = 0;
  selectedDataLeft: Shipment[] = [];
  checkSubmit: boolean = false;
  //
  dataSourceRight: Shipment[] = [];
  listShipmentWarehousedOnTabOne: Shipment[] = [];
  selectedDataRight: Shipment[] = [];
  totalShipmentBoxRight: number = 0;
  ///
  //
  totalBoxsLeft: number = 0;
  totalShipmentInPackageLeft: number = 0;
  totalPackageLeft: number = 0;
  dataFilter: ListShipmentDeliveryPlaceFilter = new ListShipmentDeliveryPlaceFilter();
  // Filter
  emps: SelectModel[] = [];
  empFilterd: string[] = [];
  selectedEmp: any;

  drivers: SelectModel[] = [];
  driverFiltered: string[] = [];
  selectedDriver: any;

  trucks: SelectModel[] = [];
  compartments: SelectModel[] = [];
  currentUser: User = new User();
  toHubs: SelectModel[] = [];
  toDistricts: SelectModel[] = [];
  toWards: SelectModel[] = [];
  deliveryVehiclesTypes: SelectModel[] = [];
  toStreetFiltered: string[] = [];
  deliveryVehiclesTypeContact: SelectModel[] = [];
  toStreetContact: Street[] = [];
  toStreetContactFiltered: string[] = [];
  typeShipmentBoxes: any[] = [
    { label: '--Chọn loại hàng--', value: null },
    { label: 'Giao tại trạm', value: 1 },
    { label: 'Giao tận nơi', value: 2 },
    { label: 'Hàng khẩn', value: 3 }
  ]

  // Modal
  bsModalRef: BsModalRef;
  bsPriceDetailModalRef: BsModalRef;

  selectedPaymentMethodValue: number;
  totalrecordsShipmentBoxs: number = 0;
  totalrecordsShipmentBoxsAhamove:number = 0;
  isDelivery: boolean = false;
  listShipmentBoxs: Shipment[] = [];
  bsModalRefLo: BsModalRef;
  pageNumberModal: number = 1
  pageSizeModal: number = 20
  //
  totalShipmentBoxLeft: number = 0;
  pageNumberRight: number = 1;
  pageSizeRight: number = 20;
  ///
  addressFrom: MenuItem[] = [];
  addressTo: MenuItem[] = [];
  activeIndex: number = 0;
  //
  paymentMethods:SelectModel[]=[
    {label:'Người gửi trả phí ship bằng tiền mặt',value:'CASH'},
    {label:'Người gửi trả phí ship bằng ví Aha',value:'BALANCE'},
    {label:'Người nhận trả phí ship bằng tiền mặt',value:'CASH_BY_RECIPIENT'}
  ];
  //
  totalPriceCOD:number = 0;
  priceDeliveryAhamove:number = 0;
  constructor(
    protected ngZone: NgZone,
    private authService: AuthService,
    private tplService: TPLService,
    private truckService: TruckService,
    private shipmentService: ShipmentService,
    private compartmentService: CompartmentsService,
    private hubService: HubService,
    private districtService: DistrictService,
    private wardService: WardService,
    private vehicleServices: VehicleServices,
    private streetService: StreetService,
    private messageService: MessageService,
    private bsModalService: BsModalService

  ) {
    if (google.maps.places) {
      this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
      this.sessionToken = new google.maps.places.AutocompleteSessionToken();
      this.geocoder = new google.maps.Geocoder;
    }
  }
  ngOnInit() {
    this.data.partnerId = 1;
    this.data.paymentMethod = 'BALANCE';
    this.markers = [];
    this.dataFilter.fromDate = new Date();
    this.dataFilter.toDate = new Date();
    this.hubConnect();
    this.zoom = 12;
    this.onSelectPartner();
    this.InitData();
    // this.showAddress();
  }

  async InitData() {
    await this.getCurrentUser();
    this.getListTruck();
    this.loadCompartment();
    this.loadToHub();
    this.loadToDistrict();
    this.getVehicleTypeDelivery();
  }
  ngAfterViewInit() {
    (<any>$('.ui-table-wrapper')).doubleScroll();
  }
  async hubConnect() {
    let user = (await this.authService.getAccountInfo().toPromise()).data
    if (user) {
      this.addressFrom.push({ label: user.hub.addressSMS });
      this.data.addressNoteFrom = user.hub.addressSMS;
      this.geocoder.geocode({ address: user.hub.addressSMS }, (resultsPlaceId, statusPlaceId) => {
        if (statusPlaceId === 'OK' && resultsPlaceId[0]) {
          const latlng = resultsPlaceId[0].geometry.location;
          this.lat = latlng.lat();
          this.lng = latlng.lng();
          this.markersUser = { id: 1, lat: latlng.lat(), lng: latlng.lng(), label: 'A', draggable: false, icon: this.icon, isOnline: true, data: null };
          this.markers.push(this.markersUser);
        }
      });

    }
  }

  async onSelectedToStreetFilter(dt: any) {
    let find = this.toStreetContact.find(f => f.name == this.dataFilter.shippingAddress);
    if (find) {
      this.dataFilter.toDistrictId = find.districtId;
      this.loadToWard();
      this.dataFilter.toWardId = find.wardId;
      this.search(dt);
    }
  }
  onClearToStreetFilter(dt: any) {
    this.dataFilter.toDistrictId = null;
    this.dataFilter.toWardId = null;
    this.search(dt);
  }

  async filterToStreetContact(event) {
    let value = event.query ? event.query : '%';
    this.toStreetContact = await this.streetService.getStreetByStreetNameAsync(value, null, null, this.currentUser.hub.provinceId, null, null);
    this.toStreetContactFiltered = this.toStreetContact.map(x => x.name);
  }

  onSelectPartner() {
    if (this.data.partnerId == 1) {
      this.getListServiceAhamove();
    }
  }
  async getListServiceAhamove() {
    this.listServiceAhamove = [];
    const res = await this.tplService.getListServiceAhamove(this.lat, this.lng);
    if (res) {
      res.map(map => {
        this.listServiceAhamove.push({ label: `${map.name_vi_vn} - ${map.description_vi_vn}(${map.fee_description_vi_vn})`, value: map._id })
      });
    }
  }
  AddaddressTo() {
    this.markers = [];
    this.latlng = [];
    this.markers.push(this.markersUser);
    this.markers.push({
      id: 2,
      lat: this.data.latTo,
      lng: this.data.lngTo,
      label: 'B',
      draggable: false,
      icon: this.icon,
      isOnline: true,
      data: this.data,
    });
    this.markers.map(map => {
      this.latlng.push([map.lat, map.lng])
    })

  }
  selectDataLeft() {

  }

  onPageChangeIssue(event: any) {

  }

  updateSearchGoogleTo() {
    this.loadingAutoCompleteAddressTo = true;
    if (this.data.addressNoteTo.length < 5) {
      return;
    }
    if (this.data.addressNoteTo) {
      if (this.data.addressNoteTo === '') {
        this.autocompleteItemsTo = [];
        this.isSuccessLocationTo = false;
        return;
      }
      if (!google.maps.places) {
        this.loadingAutoCompleteAddressTo = false;
        return false;
      }
      this.autocompleteItemsTo = [];
      this.loadingAutoCompleteAddressTo = true;
      clearTimeout(this.timerAutoCompleteAddress);
      this.timerAutoCompleteAddress = setTimeout(async () => {
        await this.GoogleAutocomplete.getPlacePredictions({
          input: this.data.addressNoteTo,
          componentRestrictions: { country: ['vi', 'vn', 'vn', 'vn', 'vn'] },
          offset: 3,
          language: 'vi',
          sessionToken: this.sessionToken
        },
          (predictions, status) => {
            this.autocompleteItemsTo = [];
            this.cloneSearchGoogleTo = this.data.addressNoteTo;
            this.loadingAutoCompleteAddressTo = false;
            this.ngZone.run(() => {
              if (predictions) {
                this.isSuccessLocationTo = true;
                predictions.forEach((prediction) => {
                  prediction.description = prediction.description.replace('Thành phố ', '').replace(', Việt Nam', '').replace('Hồ Chí Minh', 'HCM');
                  this.autocompleteItemsTo.push(prediction);
                });
              } else {
                this.isSuccessLocationTo = false;
              }
              if (status === 'ZERO_RESULTS') {
              }
            });
          });
      }, 1000);
    } else {
      this.isSuccessLocationTo = false;
      this.autocompleteItemsTo = [];
    }
  }

  updateSearchGoogleFrom() {
    this.loadingAutoCompleteAddressFrom = true;
    if (this.data.addressNoteFrom.length < 5) {
      return;
    }
    if (this.data.addressNoteFrom) {
      if (this.data.addressNoteFrom === '') {
        this.autocompleteItemsFrom = [];
        this.isSuccessLocationFrom = false;
        return;
      }
      if (!google.maps.places) {
        this.loadingAutoCompleteAddressFrom = false;
        return false;
      }
      this.autocompleteItemsFrom = [];
      this.loadingAutoCompleteAddressFrom = true;
      clearTimeout(this.timerAutoCompleteAddress);
      this.timerAutoCompleteAddress = setTimeout(async () => {
        await this.GoogleAutocomplete.getPlacePredictions({
          input: this.data.addressNoteFrom,
          componentRestrictions: { country: ['vi', 'vn', 'vn', 'vn', 'vn'] },
          offset: 3,
          language: 'vi',
          sessionToken: this.sessionToken
        },
          (predictions, status) => {
            this.autocompleteItemsFrom = [];
            this.cloneSearchGoogleFrom = this.data.addressNoteFrom;
            this.loadingAutoCompleteAddressFrom = false;
            this.ngZone.run(() => {
              if (predictions) {
                this.isSuccessLocationFrom = true;
                predictions.forEach((prediction) => {
                  prediction.description = prediction.description.replace('Thành phố ', '').replace(', Việt Nam', '').replace('Hồ Chí Minh', 'HCM');
                  this.autocompleteItemsFrom.push(prediction);
                });
              } else {
                this.isSuccessLocationFrom = false;
              }
              if (status === 'ZERO_RESULTS') {
              }
            });
          });
      }, 1000);
    } else {
      this.isSuccessLocationFrom = false;
      this.autocompleteItemsFrom = [];
    }
  }
  keyUpInput(data: Shipment, event: any) {
    if (event.value > data.totalItem) {
      event.value = data.totalItem;
      data.totalItemTF = data.totalItem;
      this.messageService.add({
        severity: Constant.messageStatus.warn,
        detail: "Số lượng kiện lớn hơn số lượng kiện trong lô!",
      })
    }
    if (event.value <= 0) {
      event.value = 1;
      data.totalItemTF = 1;
      this.messageService.add({
        severity: Constant.messageStatus.warn,
        detail: "Số lượng kiện phải lớn hơn 0!",
      })
    }
  }

  async TransferToPartner(templete:TemplateRef<any>) {
    if(!this.data.serviceId){
      this.messageService.add({ severity: Constant.messageStatus.warn, detail: 'Vui lòng chọn dịch vụ' });
      return;
    }

    if(!this.data.paymentMethod){
      this.messageService.add({ severity: Constant.messageStatus.warn, detail: 'Vui lòng chọn phương thức thanh toán' });
      return;
    }

    
    if(this.listShipmentWarehousedOnTabOne.length == 0){
      this.messageService.add({ severity: Constant.messageStatus.warn, detail: 'Vui lòng chọn hàng' });
      return;
    }
    
    this.totalPriceCOD = 0;
    this.data.path = [];
    this.data.orderTime = '0';
    this.data.path.push({lat:this.lat,lng:this.lng,address:this.data.addressNoteFrom,short_address:'',name:'CTTNHH Thành Bưởi',mobile:'0329502704',remarks:'',cod:0});
    this.data.path.push({lat:this.data.latTo,lng:this.data.lngTo,address:this.data.addressNoteTo,short_address:'',name:this.listShipmentWarehousedOnTabOne[0].receiverName,mobile:this.listShipmentWarehousedOnTabOne[0].receiverPhone,remarks:'',cod:0});
    this.data.items =[];
    let modelGetPrice =[];
    this.data.shipmentBoxs = [];
    
    
    this.listShipmentWarehousedOnTabOne.map(map=>{
      modelGetPrice.push({shipmentNumberS:map.shipmentNumberS,totalItem:map.totalItem,totalPrice:0})
      let model: AssignDeliveryModel = new AssignDeliveryModel();
      model.shipmentNumberS = map.shipmentNumberS;
      model.totalItem = map.totalItem;
      this.data.shipmentBoxs.push(model);
    });

    if(this.data.path.length < 2 || !this.lat || !this.data.latTo){
      this.messageService.add({ severity: Constant.messageStatus.warn, detail: 'Vui lòng chọn địa chỉ' });
      return;
    }
    this.checkSubmit = true;
    const data = await this.shipmentService.getListPriceByShipmentIdToAhamove(modelGetPrice);
    if(data){
      data.map(map=>{
        this.totalPriceCOD += map.totalPrice;
        this.data.items.push({_id:map.structureCode,num:map.totalItem,name:map.content,price:map.totalPrice,shipmentNumberS:map.shipmentNumberS})
      });
    }
    const est =  await this.estimatedFee();
    this.checkSubmit = false;
    if(!est){
      return
    }
    this.bsModalRef = this.bsModalService.show(templete, {
      class: "inmodal bounceInRight modal-lg", backdrop: 'static', keyboard: false
    });
    
  }

  async confirmToPartner(){
    this.data.path[1].cod = Math.round(this.totalPriceCOD);
    this.checkSubmit = true;
    const res = await this.tplService.createOrderAhamove(this.data);
    this.checkSubmit = false;
    if(res){
      this.listShipmentWarehousedOnTabOne =[];
      this.messageService.add({ severity: Constant.messageStatus.success, detail: 'Tạo đơn thành công' });
      this.bsModalRef.hide();
      this.loadDatasourceModalRight();
    }
  }

  async estimatedFee(){
    const res = await this.tplService.estimatedFee(this.data);
    if(res){
      this.priceDeliveryAhamove = res.total_price;
    }
    return res;
  }

  selectAddressTo(predictions) {
    this.addressTo = [];
    this.autocompleteItemsTo = [];
    this.data.addressNoteTo = predictions.description;
    this.addressTo.push({label:this.data.addressNoteTo});
    this.geocoder.geocode({ placeId: predictions.place_id }, (resultsPlaceId, statusPlaceId) => {
      if (statusPlaceId === 'OK' && resultsPlaceId[0]) {
        const latlng = resultsPlaceId[0].geometry.location;
        this.loadingAutoCompleteAddressTo = false;
        this.data.latTo = latlng.lat();
        this.data.lngTo = latlng.lng();
        this.isSuccessLocationTo = false;
        this.AddaddressTo();
      }
    });
  }
  selectAddressFrom(predictions) {
    this.autocompleteItemsFrom = [];
    this.addressFrom = [];
    this.data.addressNoteFrom = predictions.description;
    this.addressFrom.push({ label: this.data.addressNoteFrom });
    this.geocoder.geocode({ placeId: predictions.place_id }, (resultsPlaceId, statusPlaceId) => {
      if (statusPlaceId === 'OK' && resultsPlaceId[0]) {
        const latlng = resultsPlaceId[0].geometry.location;
        this.lat = latlng.lat();
        this.lng = latlng.lng();
        this.markersUser = { id: 1, lat: latlng.lat(), lng: latlng.lng(), label: 'A', draggable: false, icon: this.icon, isOnline: true, data: null };
        this.isSuccessLocationFrom = false;
        this.AddaddressTo();
      }
    });
  }

  isActiveSearchGoogleTo(type) {
    return type === this.activeSearchGoogleTo;
  }
  loadTextGoogleMapTo(autocompleteItem): string {
    let text = autocompleteItem.description;
    let description = '';

    var matchStart = this.change_alias(text).toLowerCase().indexOf("" + this.change_alias(this.cloneSearchGoogleTo).toLowerCase() + "");
    var matchEnd = matchStart + this.cloneSearchGoogleTo.length - 1;
    var beforeMatch = text.slice(0, matchStart);
    var matchText = text.slice(matchStart, matchEnd + 1);
    var afterMatch = text.slice(matchEnd + 1);

    description = beforeMatch + matchText + afterMatch;

    if (text.length < description.length) {
      return text;
    } else {
      return beforeMatch + "<b>" + matchText + "</b>" + afterMatch;
    }
  }
  isActiveSearchGoogleFrom(type) {
    return type === this.activeSearchGoogleFrom;
  }
  loadTextGoogleMapFrom(autocompleteItem): string {
    let text = autocompleteItem.description;
    let description = '';

    var matchStart = this.change_alias(text).toLowerCase().indexOf("" + this.change_alias(this.cloneSearchGoogleFrom).toLowerCase() + "");
    var matchEnd = matchStart + this.cloneSearchGoogleFrom.length - 1;
    var beforeMatch = text.slice(0, matchStart);
    var matchText = text.slice(matchStart, matchEnd + 1);
    var afterMatch = text.slice(matchEnd + 1);

    description = beforeMatch + matchText + afterMatch;

    if (text.length < description.length) {
      return text;
    } else {
      return beforeMatch + "<b>" + matchText + "</b>" + afterMatch;
    }
  }
  async getListShipmentDeliveryPlace() {
    let dataFilter = JSON.parse(JSON.stringify(this.dataFilter));

    if (dataFilter.fromDate) dataFilter.fromDate = SearchDate.formatToISODate(dataFilter.fromDate);
    if (dataFilter.toDate) dataFilter.toDate = SearchDate.formatToISODate(dataFilter.toDate);

    this.listShipmentWarehousedOnTabOne.map(x => {
      if (!x.isLo) {
        dataFilter.shipmentNumberSs.push(x.shipmentNumberS);
      }
    })
    this.checkSubmit = true;
    const data = await this.shipmentService.getListShipmentDeliveryPlaceNew(dataFilter);
    this.checkSubmit = false;
    if (data) {
      this.dataSourceLeft = data;
      this.totalRecordLeft = data.length > 0 ? data[0].totalCount : 0;
      this.totalShipmentInPackageLeft = data.length > 0 ? data[0].totalShipmentInPackage : 0;
      this.totalPackageLeft = data.length > 0 ? data[0].totalPackage : 0;
      this.totalBoxsLeft = data.length > 0 ? data[0].totalBoxs : 0;
      this.listShipmentWarehousedOnTabOne.map(x => {
        if (x.isLo) {
          let findSL = this.dataSourceLeft.find(y => y.shipmentNumberS == x.shipmentNumberS && y.isDeliveryPlace == x.isDeliveryPlace)
          if (findSL && findSL.totalItem > x.totalItem) {
            findSL.totalItem = findSL.totalItem - x.totalItem;
          }
          else {
            let finIndex = this.dataSourceLeft.findIndex(y => y.shipmentNumberS == x.shipmentNumberS && y.isDeliveryPlace == x.isDeliveryPlace);
            if (finIndex >= 0) {
              this.dataSourceLeft.splice(finIndex, 1);
              this.totalRecordLeft--;
            }
          }
        }
      });
    }
  }

  onPageChangeLeft(event: LazyLoadEvent) {
    this.dataFilter.pageNumber = event.first / event.rows + 1;
    this.dataFilter.pageSize = event.rows;
    this.getListShipmentDeliveryPlace();
  }

  async getCurrentUser() {
    this.currentUser = await this.authService.getAccountInfoAsync();
  }

  async getListTruck() {
    this.trucks = await this.truckService.getSelectModelAllTruckAsync();
  }

  async loadCompartment() {
    this.compartments = await this.compartmentService.getSelectModelCompartmentByHubIdAsync(this.currentUser.hubId);
  }

  async loadToHub() {
    this.toHubs = await this.hubService.getSelectModelStationHubByPoIdAsync(this.currentUser.hub.poHubId);
  }

  async loadToDistrict() {
    this.toDistricts = await this.districtService.getSelectModelDistrictByProvinceIdAsync(this.currentUser.hub.provinceId);
  }

  async loadToWard() {
    this.toWards = await this.wardService.getSelectModelWardByDistrictIdAsync(this.dataFilter.toDistrictId, this.currentUser.hub.provinceId);
  }

  async getVehicleTypeDelivery() {
    this.deliveryVehiclesTypes = await this.vehicleServices.getAllSelectModelAsync(true, false);
    this.deliveryVehiclesTypeContact = JSON.parse(JSON.stringify(this.deliveryVehiclesTypes));
    this.deliveryVehiclesTypeContact.shift();
  }

  search(dt: any) {
    if (dt) dt.reset();
    this.dataFilter.pageNumber = 1;
    this.getListShipmentDeliveryPlace();
  }

  openModalDeliveryShipmentBoxs(templete: TemplateRef<any>, isDelivery: boolean, tb1?: Table, tb2?: Table) {
    // if (!this.data.latTo) {
    //   this.messageService.add({
    //     severity: Constant.messageStatus.warn,
    //     detail: "Vui lòng nhập địa chỉ giao!",
    //   })
    //   return;
    // }
    if (tb1) {
      tb1.reset();
    }
    if (tb2) {
      tb2.reset();
    }
    this.totalrecordsShipmentBoxs = 0;
    let isLo = false;
    this.isDelivery = isDelivery;
    if (isDelivery) {
      if (this.selectedDataLeft.length == 0) {
        this.messageService.add({
          severity: Constant.messageStatus.warn,
          detail: "Vui lòng chọn kiện hoặc lô hàng!",
        });
        SoundHelper.getSoundMessage(Constant.messageStatus.warn);
        return;
      }

      this.selectedDataLeft.map(x => {
        if (x.isLo) {
          isLo = true;
          this.totalrecordsShipmentBoxs++;
          x['totalItemTF'] = x.totalItem;
        }
      });
      this.listShipmentBoxs = JSON.parse(JSON.stringify(this.selectedDataLeft.filter(x => x.isDeliveryPlace == true)));
    }
    else {
      if (this.selectedDataRight.length == 0) {
        this.messageService.add({
          severity: Constant.messageStatus.warn,
          detail: "Vui lòng chọn kiện hoặc lô hàng!",
        });
        SoundHelper.getSoundMessage(Constant.messageStatus.warn);
        return;
      }

      this.selectedDataRight.map(x => {
        if (x.isLo) {
          isLo = true;
          this.totalrecordsShipmentBoxs++;
          x['totalItemTF'] = x.totalItem;
        }
      });
      this.listShipmentBoxs = JSON.parse(JSON.stringify(this.selectedDataRight));
    }

    if (isLo) {
      this.bsModalRefLo = this.bsModalService.show(templete, {
        class: "inmodal bounceInRight modal-l", backdrop: 'static', keyboard: false
      });
    }
    else {
      if (isDelivery) {
        this.transferShipmentBox();
      }
      else {
        this.cancelShipmentSelected();
      }
    }
  }

  async transferShipmentBox() {
    let isvalid = true;
    this.listShipmentBoxs.map(x => {
      if (x.isLo) {
        if (x.totalItemTF > x.totalItem) {
          this.messageService.add({
            severity: Constant.messageStatus.warn,
            detail: "Số lượng kiện nhập kho lớn hơn số lượng kiện trong lô!",
          })
          isvalid = false;
          return;
        }
        if (x.totalItemTF <= 0) {
          this.messageService.add({
            severity: Constant.messageStatus.warn,
            detail: "Số lượng kiện nhập kho phải lớn hơn 0!",
          })
          isvalid = false;
          return;
        }
      }
    })

    if (!isvalid) {
      SoundHelper.getSoundMessage(Constant.messageStatus.warn);
      return;
    }
    this.listShipmentBoxs.map(x => {

      // table Right
      let findSR = this.listShipmentWarehousedOnTabOne.find(s => s.shipmentNumberS == x.shipmentNumberS && s.isDeliveryPlace == true);
      if (findSR) {
        if (x.isLo) {
          findSR.totalItem = findSR.totalItem + x.totalItemTF;
        }
      }
      else {
        if (x.isLo) {
          x.totalItem = x.totalItemTF;
        }
        this.listShipmentWarehousedOnTabOne.unshift(x);
      }

      //table Left
      let findSL = this.dataSourceLeft.find(s => s.shipmentNumberS == x.shipmentNumberS && s.isDeliveryPlace == true);
      if (findSL) {
        if (findSL.isLo && (findSL.totalItem - x.totalItemTF) >= 1) {
          findSL.totalItem = findSL.totalItem - x.totalItemTF;
        }
        else {
          let findIndex = this.dataSourceLeft.findIndex(y => y.shipmentNumberS == x.shipmentNumberS && y.isDeliveryPlace == true);
          if (findIndex >= 0) {
            this.dataSourceLeft.splice(findIndex, 1);
            this.totalRecordLeft--;
          }
        }
      }
    });
    this.loadDatasourceModalRight()
    if (this.dataSourceLeft.length == 0) {
      this.pageNumberModal = 1
      this.getListShipmentDeliveryPlace();
    }
    this.selectedDataLeft = [];
    if (this.bsModalRefLo)
      this.bsModalRefLo.hide();
  }

  cancelShipmentSelected() {
    let isvalid = true;
    this.listShipmentBoxs.map(x => {
      if (x.isLo) {
        if (x.totalItemTF > x.totalItem) {
          this.messageService.add({
            severity: Constant.messageStatus.warn,
            detail: "Số lượng kiện gỡlớn hơn số lượng kiện trong lô!",
          })
          isvalid = false;
          return;
        }
        if (x.totalItemTF <= 0) {
          this.messageService.add({
            severity: Constant.messageStatus.warn,
            detail: "Số lượng kiện gỡ phải lớn hơn 0!",
          })
          isvalid = false;
          return;
        }
      }
    })

    if (!isvalid) {
      SoundHelper.getSoundMessage(Constant.messageStatus.warn);
      return;
    }

    this.listShipmentBoxs.map(x => {
      // table Left
      let findSL = this.dataSourceLeft.find(s => s.shipmentNumberS == x.shipmentNumberS && s.isDeliveryPlace == x.isDeliveryPlace);
      if (findSL) {
        if (x.isLo) {
          findSL.totalItem = findSL.totalItem + x.totalItemTF;

        }
      }
      else {
        if (x.isLo) {
          x.totalItem = x.totalItemTF;
        }
        this.dataSourceLeft.unshift(x);
        this.totalRecordLeft++;
      }

      //table Right
      let findSR = this.listShipmentWarehousedOnTabOne.find(s => s.shipmentNumberS == x.shipmentNumberS && s.isDeliveryPlace == x.isDeliveryPlace);
      if (findSR) {
        if (findSR.isLo && (findSR.totalItem - x.totalItemTF) >= 1) {
          findSR.totalItem = findSR.totalItem - x.totalItemTF;
          if (findSR.shipmentBoxIds && findSR.shipmentBoxIds.length > x.totalItemTF) {
            let countIdRemove = findSR.shipmentBoxIds.length - x.totalItemTF;
            findSR.shipmentBoxIds.splice(countIdRemove);
          }
          else {
            findSR.shipmentBoxIds = [];
          }
        }
        else {
          let findIndex = this.listShipmentWarehousedOnTabOne.findIndex(y => y.shipmentNumberS == x.shipmentNumberS && y.isDeliveryPlace == x.isDeliveryPlace);
          if (findIndex >= 0) {
            this.listShipmentWarehousedOnTabOne.splice(findIndex, 1);
          }
        }
      }
    });
    this.selectedDataRight = [];
    this.messageService.add({
      severity: Constant.messageStatus.success,
      detail: "Gỡ kiện thành công",
    })
    SoundHelper.getSoundMessage(Constant.messageStatus.success);
    this.pageNumberRight = 1
    this.loadDatasourceModalRight()
    this.selectedDataRight = [];
    if (this.dataSourceLeft && this.dataSourceLeft.length > this.pageSizeModal) {
      this.getListShipmentDeliveryPlace();
    }
    if (this.bsModalRefLo)
      this.bsModalRefLo.hide();
  }

  async loadDatasourceModalRight() {

    this.totalShipmentBoxRight = 0;
    let indexStart = ((this.pageNumberRight * this.pageSizeRight) - this.pageSizeRight);
    if (this.pageNumberRight == 1) {
      this.dataSourceRight = this.listShipmentWarehousedOnTabOne.slice(0, this.pageSizeRight);
    }
    else {
      this.dataSourceRight = this.listShipmentWarehousedOnTabOne.slice(indexStart, (indexStart + this.pageSizeRight))
    }
    if (this.listShipmentWarehousedOnTabOne) {
      this.listShipmentWarehousedOnTabOne.map(x => {
        this.totalShipmentBoxRight += x.totalItem;
      })
    }
  }

  change_alias(alias) {
    let str = alias;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, ' ');
    str = str.replace(/ + /g, ' ');
    str = str.trim();
    return str;
  }
}
